import {
    QUEUED_PATIENTS_FAILURE,
    QUEUED_PATIENTS_REQUEST,
    QUEUED_PATIENTS_SUCCESS,
    REORDER_QUEUED_PATIENTS_SAGA_TYPE
  } from '../actions/actionTypes';
  
  const initialState = {
    queuedPatientList: [],
    isFetchingQueuedPatientList: false,
    isErrorInQueuedPatientList: null,
  };
  const queuedPatient = (state, action) => {
    if (typeof state === 'undefined') {
      return initialState;
    } else {
      switch (action.type) {
        case QUEUED_PATIENTS_REQUEST:
          return {
            ...state,
            isFetchingQueuedPatientList: true,
            isErrorInQueuedPatientList: null,
          };
        case QUEUED_PATIENTS_SUCCESS:
          return {
            ...state,
            isFetchingQueuedPatientList: false,
            queuedPatientList: action.payload,
            isErrorInQueuedPatientList: null,
          };
        case QUEUED_PATIENTS_FAILURE:
          return {
            ...state,
            isFetchingQueuedPatientList: false,
            isErrorInQueuedPatientList: 'SomeThing went wrong.',
          };
        case REORDER_QUEUED_PATIENTS_SAGA_TYPE:
          return {
            ...state,
            isFetchingQueuedPatientList: false,
            queuedPatientList: [...action.payload],
            isErrorInQueuedPatientList: null,
          }
        default:
          return state;
      }
    }
  };
  export default queuedPatient;